var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('b-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }